export type AuthApiHandle =
  | `/interface/rules`
  | `/interface/rules/accesses`
  | `/interface/rules_brief`
  | `/interface/user_rules`
  | `/interface/rule/${string}`
  | `/interface/rule`
  | `/interface/rules/actions`
  | `/interface/update_tag/user/${string}`
  | `/interface/update_tag_by_service/user/${string}`
  | `/user/notice/${string}`
  | `/user/notices`
  | `/user/notice/send`
  | `/user/notices/count`
  | `/users/attribute`
  | `/user/attribute/${string}/value`
  | `/users/attribute/${string}`
  | `/attribute/${string}`
  | `/attributes/brief`
  | `/attributes`
  | `/attributes/map`
  | `/attributes/value_types_operators`
  | `/attribute`
  | `/login`
  | `/login_without_session`
  | `/login/union`
  | `/oauth_login`
  | `/api_token_login`
  | `/oidc/login/${string}`
  | `/oidc/callback/${string}`
  | `/oidc/user_info/test`
  | `/oidc/user_info`
  | `/ldap/user_info/test`
  | `/logout`
  | `/keep_alive`
  | `/merge/password/login`
  | `/merge/ldap/login`
  | `/merge/oidc/login/${string}`
  | `/merge/methods`
  | `/ldap/settings`
  | `/ldap/names/active`
  | `/ldap/names`
  | `/ldap/${string}`
  | `/ldap`
  | `/ldap/example/templates`
  | `/ldap/check_connection`
  | `/logs/${string}/search`
  | `/opensearch/cursor/close`
  | `/logs/${string}/field_caps`
  | `/logs/audit_log_types`
  | `/idp/settings`
  | `/idp/names/active`
  | `/idp/names`
  | `/idp/${string}`
  | `/idp`
  | `/internal/user`
  | `/api_tokens/${string}`
  | `/api_tokens`
  | `/api_tokens/${string}/deactivate`
  | `/user/session/${string}`
  | `/users/session`
  | `/users/sessions`
  | `/profile`
  | `/settings`
  | `/settings/${string}`
  | `/user/test/websocket`
  | `/reset`
  | `/client-config`
  | `/sentry-tunnel`
  | `/user/ids`
  | `/users`
  | `/user`
  | `/user/map`
  | `/user/languages`
  | `/user/${string}/map`
  | `/user/${string}/map/system`
  | `/user/${string}/brief`
  | `/user/brief/${string}`
  | `/user/${string}`
  | `/user/su`
  | `/user/password`
  | `/user/language`
  | `/user/${string}/password`
  | `/user/${string}/status`
  | `/user/${string}/reset_password`
  | `/`;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export interface AuthInstance extends AxiosInstance {
  get<T = any, R = AxiosResponse<T>, P extends string = AuthApiHandle>(
    url: P,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  delete<T = any, R = AxiosResponse<T>, P extends string = AuthApiHandle>(
    url: P,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  post<T = any, R = AxiosResponse<T>, P extends string = AuthApiHandle>(
    url: P,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  put<T = any, R = AxiosResponse<T>, P extends string = AuthApiHandle>(
    url: P,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
}

import axios from 'axios';
import { AXIOS_NO_CACHE_HEADERS } from '@/shared/api/no-cache-headers';
import i18n from '@/shared/config/i18n';

export const authInstance = axios.create({
  baseURL: '/api/auth/v3',
  headers: AXIOS_NO_CACHE_HEADERS,
}) as AuthInstance;

i18n.on('languageChanged', (lng) => {
  authInstance.defaults.headers.common['Accept-Language'] = lng;
});